import { Container, Row, Col, Tab } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../img/PAGWEB-Acreditta-ICONTEC-2024.jpg";
import projImg2 from "../img/PAGWEB-Acreditta-IQNet-2024.jpg";
import projImg3 from "../img/PAGWEB-Acreditta-Anexo-2024.jpg";
import "../css/Anexos.css";
import "animate.css";
import TrackVisibility from "react-on-screen";
import Footer from "./Footer";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";

function Anexos() {
  const params = useParams();

  const normalizarCertificado = (valor) => {
    if (!valor) return "";

    let certificado = valor;

    try {
      certificado = decodeURIComponent(certificado);
    } catch (error) {
      console.warn("No se pudo decodificar el certificado:", error);
    }

    // Normaliza diferentes tipos de guiones Unicode a guion normal "-"
    certificado = certificado.replace(
      /[\u2010\u2011\u2012\u2013\u2014\u2015\u2212\uFE58\uFE63\uFF0D]/g,
      "-",
    );

    // Elimina espacios al inicio y final
    certificado = certificado.trim();

    return certificado;
  };

  const certificadoNormalizado = normalizarCertificado(params.certificado);

  const Icontec = () => {
    const url =
      "https://middlewarebackprd.azurewebsites.net/api/v1/ConsultaSG/" +
      encodeURIComponent(certificadoNormalizado);

    window.open(url, "_blank");
  };

  const Iqnet = () => {
    const url =
      "https://middlewarebackprd.azurewebsites.net/api/v1/ConsultaIQ/" +
      encodeURIComponent(certificadoNormalizado);

    window.open(url, "_blank");
  };

  const Anexo = () => {
    const url =
      "https://www.huelladeconfianza.org/#/Informe/" +
      encodeURIComponent(certificadoNormalizado);

    window.open(url, "_blank");
  };

  const [list, setList] = useState([]);
  const [list1, setList1] = useState([]);

  useEffect(() => {
    if (!certificadoNormalizado) return;

    axios({
      auth: {
        username: "admin.icontec@icontec.org",
        password: "quAngEraMuSTerGerEDE",
      },
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "get",
      url:
        "https://middlewarebackprd.azurewebsites.net/api/v1/ObtenerNAnexos/" +
        encodeURIComponent(certificadoNormalizado),
    })
      .then((response) => {
        setList(response.data);
        console.log("ObtenerNAnexos:", response.data);
      })
      .catch((error) => {
        console.log("Error ObtenerNAnexos:", error);
      });
  }, [certificadoNormalizado]);

  useEffect(() => {
    if (!certificadoNormalizado) return;

    axios({
      auth: {
        username: "admin.icontec@icontec.org",
        password: "quAngEraMuSTerGerEDE",
      },
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "get",
      url:
        "https://middlewarebackprd.azurewebsites.net/api/v1/InformacionCertificados/" +
        encodeURIComponent(certificadoNormalizado),
    })
      .then((response) => {
        setList1(response.data);
        console.log("InformacionCertificados:", response.data);
      })
      .catch((error) => {
        console.log("Error InformacionCertificados:", error);
      });
  }, [certificadoNormalizado]);

  const Nombre = list1.map((item) => item.nombre);
  const Documento = list1.map((item) => item.documento);
  const FechaCertificado = list1.map((item) => item.fecha_certificado);
  const FechaVencimiento = list1.map((item) => item.fecha_vencimiento);
  const Alcance = list1.map((item) => item.alcance);

  const Localizacion = list1.map(
    (item) => item.direccion + item.ciudad + item.pais,
  );

  const projects = [
    {
      title: "ICONTEC",
      description: (
        <button
          style={{ fontFamily: "Catamaran, sans-serif" }}
          variant="contained"
          className="btn btn-light"
          color="primary"
          onClick={Icontec}
        >
          Generar
        </button>
      ),
      imgUrl: projImg1,
    },
    {
      title: "IQNET",
      description: (
        <button
          style={{ fontFamily: "Catamaran, sans-serif" }}
          variant="contained"
          className="btn btn-light"
          color="primary"
          onClick={Iqnet}
        >
          Generar
        </button>
      ),
      imgUrl: projImg2,
    },
    list === true
      ? {
          title: "ANEXOS",
          description: (
            <button
              style={{ fontFamily: "Catamaran, sans-serif" }}
              variant="contained"
              className="btn btn-light"
              color="primary"
              onClick={Anexo}
            >
              Generar
            </button>
          ),
          imgUrl: projImg3,
        }
      : {
          title: "NO CUENTA CON ANEXOS",
          imgUrl: projImg3,
        },
  ];

  return (
    <div>
      <center>
        <strong>
          <div>
            <div>
              <h2
                style={{
                  color: "#0085CA",
                  display: "inline-block",
                }}
              >
                Certifican que:
              </h2>
            </div>

            <br />

            <h3 style={{ color: "#0085CA" }}>{Nombre}</h3>

            <br />

            <br />

            <h5 style={{ color: "#002E5D" }}>
              Registra con el siguiente certificado: {certificadoNormalizado}
            </h5>

            <br />
          </div>
        </strong>
      </center>

      <section className="project" id="project">
        <br />
        <br />
        <br />

        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="skill-bx wow zoomIn">
                <Container>
                  <Row>
                    <Col size={12}>
                      <TrackVisibility>
                        {({ isVisible }) => (
                          <div
                            className={
                              isVisible
                                ? "animate__animated animate__fadeIn"
                                : ""
                            }
                          >
                            <Tab.Container
                              id="projects-tabs"
                              defaultActiveKey="first"
                            >
                              <Tab.Content
                                id="slideInUp"
                                className={
                                  isVisible
                                    ? "animate__animated animate__slideInUp"
                                    : ""
                                }
                              >
                                <Tab.Pane eventKey="first">
                                  <Row>
                                    {projects.map((project, index) => (
                                      <ProjectCard key={index} {...project} />
                                    ))}
                                  </Row>
                                </Tab.Pane>

                                <Tab.Pane eventKey="section"></Tab.Pane>
                              </Tab.Content>
                            </Tab.Container>
                          </div>
                        )}
                      </TrackVisibility>
                    </Col>
                  </Row>
                </Container>

                <img className="background-image-right" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <center>
        <Footer />
      </center>
    </div>
  );
}

export default Anexos;
